import bus from '../util/eventBus';

const request = async (url, data) => {
  const res = await fetch(url, {
    method: 'POST',
    body: data,
  });

  return res.text();
};

const loadMore = (trigger, target) => {
  const btn = document.querySelector(trigger);
  const { ewg } = window;

  if (btn) {
    btn.addEventListener('click', e => {
      const targetEl = e.target || e.srcElement;
      const targetElement = document.querySelector(target);
      const { ppp } = targetElement.closest('[data-ppp]').dataset;

      const origBtnText = targetEl.innerText;
      targetEl.innerText = ewg.namespace.loading;
      targetEl.classList.add('disabled');

      const formData = new FormData();
      formData.append('action', 'loadmore');
      formData.append('posts_per_page', ppp);
      formData.append('page', ewg.current_page);

      request(ewg.ajaxurl, formData).then(r => {
        targetEl.innerHTML = origBtnText;

        const resultWrap = document.querySelector(target);
        resultWrap.innerHTML += r;

        bus.emit('ewg-social-grid-recalc');
        // eslint-disable-next-line no-plusplus
        ewg.current_page++;

        if (ewg.current_page >= ewg.max_page) {
          targetEl.classList.add('disabled');
          targetEl.innerText = ewg.namespace.no_posts;
        } else {
          targetEl.classList.remove('disabled');
        }
      });
    });
  }
};

export default loadMore;



// WEBPACK FOOTER //
// ./src/scripts/modules/loadmore.js